<template>
<h1 class="text-center">Checkboxes Toggles</h1>
</template>

<script>
export default {
  name: "CheckboxesToggles"
}
</script>

<style scoped>

</style>